import { xhr } from '@/api/config/Repository'
import DocumentationRepository from '../DocumentationFactoryRepository'
import DocumentationSupplierRequest from '@/services/documentation/models/DocumentationSupplierRequest'
import DocumentSupplierResponseDTO from '../dto/DocumentSupplierResponseDTO'
import DocumentationWarehouseRequest from '@/services/documentation/models/DocumentationWarehouseRequest'
import DocumentWarehouseResponseDTO from '../dto/DocumentWarehouseResponseDTO'
import DocumentationSupplierResponse from '@/services/documentation/models/DocumentationSupplierResponse'
export default class DocumentationRepositoryImpl implements DocumentationRepository {
  async getDocumentationSupplierData (param: DocumentationSupplierRequest): Promise<DocumentationSupplierResponse> {
    const countryTemp = param.countryList.length > 0 ? param.countryList : []

    const reqBody: DocumentationSupplierRequest = {
      pageNumber: param.pageNumber,
      pageSize: param.pageSize,
      sortBy: param.sortBy,
      countryList: countryTemp,
      supplierName: param.supplierName
    }
    const endpoint = 'md/fetchSupplierInfoDoc'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<DocumentationSupplierRequest, any>(endpoint, reqBody, { headers })
    return {
      content: response.data,
      status: response.status,
      totalCount: response.data
    }
  }

  async getDocumentationSupplierExportData (param: DocumentationSupplierRequest): Promise<DocumentSupplierResponseDTO> {
    const countryTemp = param.countryList.length > 0 ? param.countryList : []
    const reqBody: DocumentationSupplierRequest = {
      countryList: countryTemp,
      supplierName: param.supplierName
    }
    const endpoint = 'md/export-supplier'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<DocumentationSupplierRequest, any>(endpoint, reqBody, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getDocumentationWarehouseData (param: DocumentationWarehouseRequest): Promise<DocumentWarehouseResponseDTO> {
    const countryTemp = param.countryList.length > 0 ? param.countryList : []
    const reqBody: DocumentationWarehouseRequest = {
      pageNumber: param.pageNumber,
      pageSize: param.pageSize,
      sortBy: param.sortBy,
      countryList: countryTemp,
      warehouseName: param.warehouseName
    }
    const endpoint = 'md/fetchWarehouseInfoDoc'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<DocumentationWarehouseRequest, any>(endpoint, reqBody, { headers })

    return {
      content: response.data,
      status: response.status,
      totalCount: response.data
    }
  }

  async getDocumentationWarehouseExportData (param: DocumentationWarehouseRequest): Promise<DocumentWarehouseResponseDTO> {
    const countryTemp = param.countryList.length > 0 ? param.countryList : []
    const reqBody: DocumentationWarehouseRequest = {
      countryList: countryTemp,
      warehouseName: param.warehouseName
    }
    const endpoint = 'md/export-warehouse'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<DocumentationWarehouseRequest, any>(endpoint, reqBody, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
